import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Navbar } from "@/components/lendx/Navbar";
import { Footer } from "@/components/lendx/Footer";
import { FloatingButtons } from "@/components/lendx/FloatingButtons";
import Home from "@/pages/Home";
import AboutPage from "@/pages/AboutPage";
import SolutionsPage from "@/pages/SolutionsPage";
import ServicePage from "@/pages/ServicePage";
import CategoryPage from "@/pages/CategoryPage";
import WhyLendXPage from "@/pages/WhyLendXPage";
import ContactPage from "@/pages/ContactPage";
import { PrivacyPage, TermsPage, DisclaimerPage } from "@/pages/LegalPages";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-white">
      <BrowserRouter>
        <ScrollManager />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/solutions/:slug" element={<ServicePage />} />
          <Route path="/business-finance" element={<CategoryPage category="business" />} />
          <Route path="/property-finance" element={<CategoryPage category="property" />} />
          <Route path="/why-lendx" element={<WhyLendXPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          <Route path="/terms-and-conditions" element={<TermsPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <FloatingButtons />
        <Toaster theme="light" position="top-center" offset="88px" mobileOffset="80px" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
